import React, { useContext, useEffect, useRef, useState } from "react";
import "./Navbar.scss";
import { useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { PageRoutes } from "../../utils/pageRoutes";
import {
  GetLogout,
  LoginTokenVerifty,
  getUserProfile,
  GetAllstageswithstsatus,
} from "../../utils/Api/api";
import { fetchIpAddress as fetchSharedIp } from "../../utils/ip";
import { clearStore } from "../../utils/indexDB/indexDB";
import { clearCmsContentCaches } from "../../utils/cmscontent/cms";
import useGeoLocation from "../geoLocation/GeoLoaction";
import { Button } from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import "../../pages/InvestorCentrer/investorCenter.scss";
import { Context, user } from "../../contextApi/contextProvider";
import { getPostStatus } from "../../utils/isPostIdPresent";
import { toast } from "react-toastify";
import { toastCommonestyle } from "../../utils/Toast";
import { ShimmerLoaderOneLine } from "../../utils/loader/ShimmerLoader";
import { useIsMobile } from "./useMoblie";
import {
  FileText,
  Building2,
  DollarSign,
  TrendingUp,
  Shield,
  Globe,
  Lock,
  X,
  ChevronDown,
  Scale,
  Moon,
  Sun,
  Clock,
  CheckCircle,
  XCircle,
  LogOut,
} from "lucide-react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
  Drawer,
  DrawerContent,
  DrawerHeader,
  DrawerTitle,
  DrawerDescription,
} from "../../utils/drawer";
import PopupModal, {
  AccessDeniedModal,
  PandingModal,
} from "../../utils/popMenu/PopModel";
import { NavbarPandingPop } from "../../utils/popMenu/navbarPandingPop";

export interface loginToken {
  access_token: string | null;
}

export interface Stage {
  stage_uid: string;
  stage_name: string;
  stage_status: string | "";
  documents?: {
    post_id: string;
    post_name: string;
    document_status: string;
  }[];
}
export interface AccessDOCOBJ {
  [key: string]: string | Stage[]; // dynamic string keys OR all_stage_info
  all_stage_info: Stage[];
}
function NavBar() {
  const isMobile = useIsMobile();
  const { userLoginData, setUserLoginData, accessDoc, setAccessDoc } =
    useContext(Context);
  const menuRef = useRef<HTMLDivElement | null>(null);
  const menuRef1 = useRef<HTMLDivElement | null>(null);
  const [menuTogle, setmenuTogle] = useState(false);
  const navigation = useNavigate();
  const loaction = useGeoLocation();
  const [userName, setUserName] = useState("");
  const [colorChange, setColorchange] = useState(true);
  const [investorMenu, setInvestoeMenu] = useState(false);
  const [ppm, setPpm] = useState(false);
  const [showAccessDenied, setShowAccessDenied] = useState(false);
  const [pendingPop, setpendingPop] = useState(false);
  const [showFinancialPopup, setShowFinancialPopup] = useState(false);
  const [showPandingBussness, setShowPandingBussness] = useState(false);
  const [ShowLockBussness, setShowLockBussness] = useState(false);
  const [loginLoading, setLoginLoading] = useState(false);
  const [sideinvestorMenu, setSideinvestorMenu] = useState(false);
  const [menuTheme, setMenuTheme] = useState<"dark" | "light">("dark");
  const [showInvestorMenu, setShowInvestorMenu] = useState(false);
  const [docId, setDocId] = useState<string | undefined>("");
  const [openMenus, setOpenMenus] = useState(false);
  const token = JSON.parse(localStorage.getItem("access_token") as string);
  interface SectionProps {
    title: string;
    icon: React.ReactNode;
    theme: "dark" | "light";
    links: {
      name: string;
      href: string;
      lock?: boolean;
      animatedLock?: boolean;
      ckeckAccess?: boolean;
      postId?: string | undefined;
      unlock?: boolean;
      www?: boolean;
    }[];
    setShowInvestorMenu: (v: boolean) => void;
  }
  useEffect(() => {
    setDocId("");
  }, [investorMenu]);
  const Section: React.FC<SectionProps> = ({
    title,
    icon,
    theme,
    links,
    setShowInvestorMenu,
  }) => {
    return (
      <div key={`${title}-${icon}`} className={`section ${theme}`}>
        <div className="section-header">
          <div className="section-icon">{icon}</div>
          <h3>{title}</h3>
        </div>
        <div className="section-links">
          {links.map((link, i) => (
            <>
              <p
                key={`investor-drop-${i}-${link.name}`}
                className={`section-link ${
                  link?.postId
                    ? accessDoc[link.postId] === "ALLOWED"
                      ? "text-green-dev"
                      : link?.postId && accessDoc[link.postId] === "PENDING"
                        ? "text-yellow-dev"
                        : link?.postId && accessDoc[link.postId] === "DENIED"
                          ? "text-red-dev"
                          : ""
                    : "text-green-dev"
                } ${title == "WWW" && !link.href && "gray-dev"}`}
                style={{ opacity: `${!link.href && title == "WWW" && 0.5}` }}
                onClick={(e) => {
                  e.stopPropagation();

                  if (title == "Intro") {
                    navigation(link.href);
                  } else if (link.postId && title == "Business Plan") {
                    if (accessDoc[link.postId] == "ALLOWED") {
                      navigation(link.href);
                    } else if (accessDoc[link.postId] == "PENDING") {
                      setShowPandingBussness(true);
                    } else if (accessDoc[link.postId] == "DENIED") {
                      setShowAccessDenied(true);
                    } else {
                      setShowLockBussness(true);
                    }
                  } else if (
                    link.postId &&
                    (title == "Investor Instrument" ||
                      title == "Corporate Governance" ||
                      title == "Financial Summary")
                  ) {
                    if (accessDoc[link.postId] == "ALLOWED") {
                      navigation(link.href);
                    } else if (accessDoc[link.postId] == "PENDING") {
                      setpendingPop(true);
                    } else if (accessDoc[link.postId] == "DENIED") {
                      setShowAccessDenied(true);
                    } else {
                      setShowFinancialPopup(true);
                    }
                  } else if (title == "Corporate Governance" && !link.postId) {
                    navigation(link.href);
                  } else {
                    if (link.www) {
                      let Api_URL: any = "";
                      const env = process.env.REACT_APP_STAGE_ENV;
                      switch (env) {
                        case "dev":
                          Api_URL = `https://dev.www.${link.href}`;
                          break;
                        case "stage":
                          Api_URL = `https://stage.www.${link.href}`;
                          break;
                        case "prod":
                          Api_URL = `https://www.${link.href}`;
                          break;
                        default:
                          Api_URL = `https://dev.www${link.href}`;
                      }
                      window.open(Api_URL, "_blank");
                      setShowInvestorMenu(false);
                    } else {
                      setShowInvestorMenu(false);
                      navigation(link.href);
                      setDocId("");
                    }
                  }
                }}
              >
                <span className="tooltip-wrapper">
                  {link.unlock && (
                    <span
                      className={`text-green ${
                        title == "WWW" && !link.href && "gray-dev"
                      }`}
                    >
                      <div className="dot" />
                      {link.name}
                    </span>
                  )}
                  {link.lock && (
                    <span
                      className={` ${
                        link?.postId && accessDoc[link.postId] === "ALLOWED"
                          ? "text-green"
                          : link?.postId && accessDoc[link.postId] === "PENDING"
                            ? "text-yellow"
                            : link?.postId &&
                                accessDoc[link.postId] === "DENIED"
                              ? "text-red"
                              : title == "WWW" && !link.href
                                ? "gray-dev"
                                : ""
                      }`}
                    >
                      <div className="dot" />
                      {link.name}
                    </span>
                  )}

                  {/* Tooltip text */}
                  {link?.postId ? (
                    <span className="tooltip-text">
                      {accessDoc[link.postId] === "PENDING"
                        ? "Access pending for approval"
                        : accessDoc[link.postId] === "DENIED"
                          ? "Access Denied"
                          : accessDoc[link.postId] === "ALLOWED"
                            ? "Access Granted"
                            : "Request Access"}
                    </span>
                  ) : (
                    <span
                      className={`tooltip-text ${
                        title == "WWW" && !link.href && "gray-dev"
                      }`}
                    >
                      {" "}
                      {title == "WWW" && !link.href
                        ? "Coming soon"
                        : "Access Granted"}
                    </span>
                  )}
                </span>

                {/* Icon handling */}
                {link.unlock && title !== "WWW" && (
                  <CheckCircle className="lock text-green" />
                )}
                {link.unlock &&
                  title == "WWW" &&
                  (link.href ? (
                    <CheckCircle className="lock text-green" />
                  ) : (
                    <Lock className="lock" />
                  ))}
                {link.lock && (
                  <>
                    {link?.postId && accessDoc[link.postId] === "ALLOWED" ? (
                      <CheckCircle className="lock text-green" />
                    ) : link?.postId && accessDoc[link.postId] === "PENDING" ? (
                      <Clock className="lock text-yellow" />
                    ) : link?.postId && accessDoc[link.postId] === "DENIED" ? (
                      <XCircle className="lock text-red" />
                    ) : (
                      <Lock className="lock" />
                    )}
                  </>
                )}
              </p>
            </>
          ))}
        </div>
      </div>
    );
  };
  const getInitials = (fullName: string) => {
    return fullName
      .split(" ")
      .filter(Boolean)
      .slice(0, 2) // take only first two words
      .map((word) => word[0].toUpperCase())
      .join("");
  };
  const fetchIpAddress = async () => {
    try {
      const ip = await fetchSharedIp();
      setUserLoginData({ ...userLoginData, ip });
      UserProfileinfo(ip);
    } catch (error) {
      setUserLoginData({ ...userLoginData, ip: "" });
      setLoginLoading(false);
      toast.error("your ip address is not found", toastCommonestyle as any);
    }
  };

  const verftyLgoinUser = async () => {
    if (token != "" && token != null && token != undefined) {
      try {
        const { data } = await LoginTokenVerifty({ access_token: token });
        if (data?.status == 200) {
          fetchIpAddress();
        }
        if (data?.status !== 200) {
          setUserLoginData({ ...userLoginData, status: 404 });
          setLoginLoading(false);
        }
      } catch (error) {
        // Notfy(error as string);
        setLoginLoading(false);
        setUserLoginData({ ...userLoginData, status: 404 });
      }
    } else {
      setLoginLoading(false);
      setUserLoginData({ ...userLoginData, status: 404 });
      await clearStore();
    }
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        menuRef.current &&
        !menuRef.current.contains(event.target as Node) &&
        menuRef1.current &&
        !menuRef1.current.contains(event.target as Node) // ✅ Cast target as Node
      ) {
        setInvestoeMenu(false);
        setSideinvestorMenu(false);
      }
    };

    document.body.addEventListener("click", handleClickOutside);
    return () => {
      document.body.removeEventListener("click", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    setLoginLoading(true);
    verftyLgoinUser();
  }, []);

  const changeNavbarColor = () => {
    if (
      window.location.pathname != PageRoutes.factSheet &&
      window.location.pathname != PageRoutes.ExecutiveSummary &&
      window.location.pathname != PageRoutes.Intro &&
      window.location.pathname != PageRoutes.qa &&
      window.location.pathname != PageRoutes.CorporateGovernancePolicy &&
      window.location.pathname != PageRoutes.faq &&
      window.location.pathname != PageRoutes.AntiFraudPolicy
    ) {
      if (window.scrollY >= 40) {
        setColorchange(false);
      } else {
        setColorchange(true);
      }
    }
  };
  const UserLogOut = async () => {
    await clearStore();
    clearCmsContentCaches();
    setUserLoginData({ ...userLoginData, status: 404 });
    localStorage.removeItem("access_token");

    const loginToLtd = { logout: "ltd" };
    const encodedData = encodeURIComponent(JSON.stringify(loginToLtd));
    let Api_URL: any = "";
    const env = process.env.REACT_APP_STAGE_ENV;
    switch (env) {
      case "dev":
        Api_URL = "https://dev.login.ticca.com/logout";
        break;
      case "stage":
        Api_URL = "https://stage.login.ticca.com/logout";
        break;
      case "prod":
        Api_URL = "https://login.ticca.com/logout";
        break;
      default:
        Api_URL = "https://dev.login.ticca.com/logout";
    }
    setTimeout(() => {
      window.location.href = `${Api_URL}?data=${encodedData}`;
    }, 100);

    try {
      const { data } = await GetLogout({
        ip_address: await userLoginData.ip,
        latitude: loaction.coordinates?.lat ?? "0.0",
        longitude: loaction.coordinates?.lng ?? "0.0",
      });
      if (data.status == 1) {
        setUserLoginData({ ...userLoginData, status: 404 });
        localStorage.removeItem("access_token");
      }
    } catch (error) {}
  };
  const allowed_stage_info = async (ip?: string) => {
    if (!token) return;
    setLoginLoading(false);
    try {
      const response = await GetAllstageswithstsatus({
        ip_address: ip,
        latitude: await loaction.coordinates.lat,
        longitude: await loaction.coordinates.lng,
      });
      if (response?.data) {
        setAccessDoc(response?.data);
        const updatedAccessDOCOBJ: AccessDOCOBJ = { ...accessDoc };
        Object.keys(updatedAccessDOCOBJ).forEach((key) => {
          const status = getPostStatus(key, response?.data?.all_stage_info);
          updatedAccessDOCOBJ[key] = status;
        });
        setAccessDoc({
          ...updatedAccessDOCOBJ,
          all_stage_info: response?.data?.all_stage_info,
        });
        setOpenMenus(true);
      }
    } catch (error) {
      setOpenMenus(false);
    }
  };
  const UserProfileinfo = async (ipA?: string) => {
    if (!token) return;
    try {
      const { data } = await getUserProfile({
        ip_address: ipA ?? "",
        latitude: loaction.coordinates?.lat ?? "0.0",
        longitude: loaction.coordinates?.lng ?? "0.0",
      });

      setUserName(`${data?.profile?.fname} ${data?.profile?.lname}`);
       sessionStorage.setItem("userData", JSON.stringify(data?.profile));
       sessionStorage.setItem("userLoginTime", new Date().toISOString());
      setLoginLoading(false);
      setUserLoginData((prev: user) => ({
        ...prev,
        status: 200,
        email: data.profile.email,
        fname: data.profile.fname,
        lname: data.profile.lname,
        phone: data.profile.phone,
        ip: ipA ?? "",
      }));
      allowed_stage_info(ipA ?? "0.0");
    } catch (error) {
      setLoginLoading(false);
      setUserLoginData({ ...userLoginData, status: 404 });
    }
  };

  useEffect(() => {
    setPpm(
      window.location.pathname === PageRoutes.ExecutiveSummary ||
        window.location.pathname === PageRoutes.Intro ||
        window.location.pathname === PageRoutes.question ||
        window.location.pathname === PageRoutes.qa ||
        window.location.pathname === PageRoutes.factSheet ||
        window.location.pathname === PageRoutes.Projections ||
        window.location.pathname === PageRoutes.ShareholderAgreement ||
        window.location.pathname === PageRoutes.businessPlan ||
        window.location.pathname === PageRoutes.ShareSubscriptionForm ||
        window.location.pathname === PageRoutes.SafeFrom ||
        window.location.pathname === PageRoutes.SafeAgreement ||
        window.location.pathname === PageRoutes.CorporateGovernancePolicy ||
        window.location.pathname === PageRoutes.faq ||
        window.location.pathname === PageRoutes.Preview ||
        window.location.pathname === PageRoutes.AntiFraudPolicy ||
        window.location.pathname === PageRoutes.WhistleblowerPolicy ||
        window.location.pathname === PageRoutes.DataSecurityPolicy ||
        window.location.pathname === PageRoutes.PrivacyPolicy ||
        window.location.pathname === PageRoutes.TeamsOfUse ||
        window.location.pathname === PageRoutes.CookiePolicy ||
        window.location.pathname === PageRoutes.InvestorRelationsPolicy
    );
    setInvestoeMenu(false);
  }, [window.location.pathname]);

  window.addEventListener("scroll", changeNavbarColor);
  const NavBarComm = () => {
    return (
      <>
        <div className="">
          {/* {ppmPop && <PpmPop setppmPop={setppmPop} />} */}
          {/* {investorPop && <InvestorPop setInvestorPop={setInvestorPop} />} */}
          {/* {pendingPop && (
            <Pending setpendingPop={setpendingPop} docName={docName} />
          )} */}
          {/* {DeniedPop && (
            <Denied setDeniedPop={setDeniedPop} docName={docName} />
          )} */}
          <NavbarPandingPop
            showAccessDenied={pendingPop}
            setShowAccessDenied={setpendingPop}
          />
          <PopupModal
            show={showFinancialPopup}
            onClose={() => setShowFinancialPopup(false)}
            title="Confidential Document"
            description="To maintain confidentiality, this document will be provided after your discussion with our CEO."
            type="accessDenied"
          />
          <AccessDeniedModal
            showAccessDenied={showAccessDenied}
            setShowAccessDenied={() => setShowAccessDenied(false)}
            deniedDocument={""}
          />
          <PopupModal
            show={ShowLockBussness}
            onClose={() => setShowLockBussness(false)}
            title="Access Requirements"
            description="Read the TICCA Intro documents to unlock CEO access."
            type="ceo"
            showRequirements
            requirements={["Intro", "FAQ", "Fact Sheet"]}
            lockedDocs={["Business Summary", "Q & A", "AI Executive Summary"]}
          />
          <PandingModal
            showAccessDenied={showPandingBussness}
            setShowAccessDenied={() => setShowPandingBussness(false)}
            deniedDocument={"Business Plan"}
          />
        </div>
        <div className="navbar-dev">
          <div className="navbar-left-menu">
            <img
              onClick={() => {
                navigation(PageRoutes.home);
              }}
              className="logo-img"
              src={`${"https://public.ticca.com/images/svg/TiccaLogo_Null_EmailVerification_WhiteRedOrangeGreen_150X33.svg"} `}
              alt="logo"
            />
            <div className="navbar-menu-list">
              <ul>
                <li>
                  <div
                    onClick={() => {
                      navigation(PageRoutes.ticcaProduct);
                    }}
                    className={`menuList-title  ${
                      PageRoutes.ticcaProduct === window.location.pathname &&
                      "active"
                    }  `}
                  >
                    What
                  </div>
                </li>
                <li>
                  <div
                    onClick={() => {
                      navigation(PageRoutes.WorkFromAnywhere);
                    }}
                    className={`menuList-title   ${
                      PageRoutes.WorkFromAnywhere ===
                        window.location.pathname && "active"
                    }  `}
                  >
                    Where
                  </div>
                </li>
                <li>
                  <div
                    onClick={() => {
                      navigation(PageRoutes.innovation);
                    }}
                    className={`menuList-title  ${
                      PageRoutes.innovation === window.location.pathname &&
                      "active"
                    } `}
                  >
                    How
                  </div>
                </li>
                <li>
                  <div
                    onClick={() => {
                      navigation(PageRoutes.aboutUs);
                    }}
                    className={`menuList-title  ${
                      PageRoutes.aboutUs === window.location.pathname &&
                      "active"
                    }  `}
                  >
                    Who
                  </div>
                </li>
                <li>
                  <div
                    onClick={() => {
                      navigation(PageRoutes.WhyChooseUs);
                    }}
                    className={`menuList-title  ${
                      PageRoutes.WhyChooseUs === window.location.pathname &&
                      "active"
                    } `}
                  >
                    Why
                  </div>
                </li>

                <li>
                  <div
                    onClick={() => {
                      navigation(PageRoutes.When);
                    }}
                    className={`menuList-title  ${
                      PageRoutes.When === window.location.pathname && "active"
                    } `}
                  >
                    When
                  </div>
                </li>
                <li>
                  <div
                    onClick={() => {
                      navigation(PageRoutes.insights);
                    }}
                    className={`menuList-title  ${
                      PageRoutes.insights === window.location.pathname &&
                      "active"
                    }  `}
                  >
                    Insights
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div style={{ marginTop: "10px" }} className="navbar-menu-list">
            <ul>
              <li>
                <div
                  onClick={() => {
                    navigation(PageRoutes.InvestorCenter);
                  }}
                  className={`menuList-title  ${
                    PageRoutes.InvestorCenter === window.location.pathname &&
                    "active"
                  } `}
                  ref={menuRef1}
                  onMouseEnter={() => {
                    setInvestoeMenu(true);
                    setSideinvestorMenu(false);
                  }}
                >
                  <span style={{ display: "flex" }}>
                    {" "}
                    <TrendingUp
                      style={{
                        margin: "-5px 5px 10px 0px",
                        paddingTop: "10px",
                        color: "white",
                      }}
                      className="investor-icon"
                    />
                    Investor
                    {userLoginData.status == 200 && openMenus && (
                      <samp>
                        <img
                          className="solution-downArrow"
                          style={{
                            transform: `${
                              investorMenu ? "rotate(0deg)" : "rotate(180deg)"
                            }`,
                          }}
                          src={
                            "https://public.ticca.com/images/svg/ArrowDown.svg"
                          }
                        />
                      </samp>
                    )}
                  </span>
                </div>
              </li>
              <li>
                <div
                  onClick={() => {
                    navigation(PageRoutes.ContactUs);
                  }}
                  className={`menuList-title  ${
                    PageRoutes.ContactUs === window.location.pathname &&
                    "active"
                  } `}
                >
                  Contact
                </div>
              </li>
              {userLoginData.status !== 404 ? (
                <li className="contact-img">
                  <div
                    ref={menuRef}
                    onMouseEnter={() => {
                      setInvestoeMenu(false);
                      setSideinvestorMenu(true);
                    }}
                    style={{ marginTop: "0px" }}
                  >
                    <img
                      src={
                        "https://public.ticca.com/images/svg/NavProfileIcon.svg"
                      }
                      alt="ContactIcon"
                    />
                  </div>
                  {sideinvestorMenu && !investorMenu && (
                    <AnimatePresence>
                      <motion.div
                        initial={{ opacity: 0, y: -10, scale: 0.95 }}
                        animate={{ opacity: 1, y: 0, scale: 1 }}
                        exit={{ opacity: 0, y: -10, scale: 0.95 }}
                        transition={{ duration: 0.2, ease: "easeOut" }}
                        onMouseLeave={() => {
                          setSideinvestorMenu(false);
                        }}
                        className="profile-dropdown contact-ab"
                      >
                        {/* <div
                        style={{ width: `${loginLoading ? "200px" : "295px"}` }}
                      >
                        {loginLoading ? (
                          <ShimmerOfCardLoader />
                        ) : (
                          <p style={{ fontFamily: "var(--OpenSans-Bold)" }}>
                            {userName}
                          </p>
                        )}
                      </div>
                      <hr />
                      <div style={{ width: "295px" }}>
                        {loginLoading ? (
                          <ShimmerOfCardLoader />
                        ) : (
                          <p style={{ fontFamily: "var(--OpenSans-Bold)" }}>
                            {userLoginData?.email}
                          </p>
                        )}
                      </div>
                      <hr />
                      <div
                        onClick={() => {
                          if (!loginLoading) UserLogOut();
                        }}
                      >
                        <img
                          style={{ width: "18px", height: "18px" }}
                          src="https://public.ticca.com/images/svg/LogOut.svg"
                          alt="logOut"
                        />
                        <p>Log-out</p>
                      </div>
                      <hr /> */}
                        {/* <div style={{ borderRadius: "0px 0px 8px 8px" }}>
                        <img
                          style={{ width: "18px", height: "18px" }}
                          src="https://public.ticca.com/images/svg/remove.svg"
                          alt="logOut"
                        />

                        <p>Remove</p>
                      </div> */}
                        <div className="gradient-bar"></div>

                        {/* Profile Header */}
                        <div className="profile-header">
                          <div className="avatar-wrapper">
                            <div className="avatar">
                              {loginLoading ? (
                                <ShimmerLoaderOneLine />
                              ) : (
                                <span>{getInitials(userName)}</span>
                              )}
                            </div>
                            <div className="online-indicator"></div>
                          </div>

                          <div className="user-info">
                            {loginLoading ? (
                              <ShimmerLoaderOneLine />
                            ) : (
                              <h3 className="user-name">{userName || "Guest"}</h3>
                            )}

                            {!loginLoading && userLoginData?.email && (
                              <p className="user-detail">{userLoginData.email}</p>
                            )}

                            {!loginLoading && userLoginData?.phone && (
                              <p className="user-detail">{userLoginData.phone}</p>
                            )}

                            {!loginLoading && userLoginData?.ip && (
                              <p className="user-meta">IP: {userLoginData.ip}</p>
                            )}

                            {!loginLoading && (() => {
                              try {
                                const t = sessionStorage.getItem("userLoginTime");
                                if (t) {
                                  return <p className="user-meta">Logged in {new Date(t).toLocaleString()}</p>;
                                }
                              } catch {}
                              return null;
                            })()}
                          </div>
                        </div>

                        {/* Divider */}
                        <div className="divider"></div>

                        {/* Logout Button */}
                        <div className="logout-wrapper">
                          <motion.button
                            whileHover={{ x: 2 }}
                            whileTap={{ scale: 0.98 }}
                            transition={{ duration: 0.15 }}
                            onClick={() => {
                              if (!loginLoading) UserLogOut();
                            }}
                            className="logout-btn"
                          >
                            <div className="logout-icon">
                              <LogOut size={16} />
                            </div>
                            <span>Log out</span>
                          </motion.button>
                        </div>
                      </motion.div>
                    </AnimatePresence>
                  )}
                </li>
              ) : (
                <>
                  <li className="contact-img">
                    <LoadingButton
                      disabled={loginLoading}
                      onClick={() => {
                        let Api_URL: any = "";
                        const env = process.env.REACT_APP_STAGE_ENV;
                        switch (env) {
                          case "dev":
                            Api_URL =
                              "https://dev.login.ticca.com/?domain=dev.www.ticca.ltd";
                            break;
                          case "stage":
                            Api_URL =
                              "https://stage.login.ticca.com/?domain=stage.www.ticca.ltd";
                            break;
                          case "prod":
                            Api_URL =
                              "https://login.ticca.com/?domain=www.ticca.ltd";
                            break;
                          default:
                            Api_URL =
                              "https://dev.login.ticca.com/?domain=dev.www.ticca.ltd";
                            break;
                        }
                        window.location.href = Api_URL;
                      }}
                      loading={loginLoading}
                      className="btn-ticca-nav login-btn"
                      type="submit"
                    >
                      {!loginLoading && "Log in"}
                    </LoadingButton>
                  </li>
                  <li className="contact-img">
                    <LoadingButton
                      loading={loginLoading}
                      disabled={loginLoading}
                      onClick={() => {
                        let Api_URL: any = "";
                        const env = process.env.REACT_APP_STAGE_ENV;
                        switch (env) {
                          case "dev":
                            Api_URL = process.env.REACT_APP_TICCA_DEV_SINUP;
                            break;
                          case "stage":
                            Api_URL = process.env.REACT_APP_TICCA_STAGE_SINUP;
                            break;
                          case "prod":
                            Api_URL = process.env.REACT_APP_TICCA_PRO_SINUP;
                            break;
                          default:
                            Api_URL = process.env.REACT_APP_TICCA_DEV_SINUP;
                            break;
                        }
                        window.location.href = Api_URL;
                      }}
                      className="btn-ticca-nav"
                      type="submit"
                    >
                      {!loginLoading && "Sign Up"}
                    </LoadingButton>
                  </li>
                </>
              )}
            </ul>
          </div>
          <div
            style={{ position: "relative" }}
            className="side-right-menu-login-dev"
          >
            {userLoginData.status == 200 && openMenus && (
              <div className="mobile-navBar">
                <button
                  onClick={() => {
                    setShowInvestorMenu(!showInvestorMenu);
                    setDocId("");
                  }}
                  className="investor-button"
                >
                  <span style={{ display: "flex" }}>
                    <TrendingUp className="investor-icon" />
                    <span className="investor-text">Investor</span>
                    <ChevronDown
                      className={`chevron ${showInvestorMenu ? "open" : ""}`}
                    />
                  </span>
                  <div className="button-bg" />
                  <div className="button-border" />
                </button>
              </div>
            )}
            {userLoginData.status == 200 ? (
              <li className="contact-img mobile-contact">
                <div
                  ref={menuRef}
                  onClick={() => {
                    setInvestoeMenu(false);
                    setSideinvestorMenu(true);
                  }}
                >
                  <img
                    src={
                      "https://public.ticca.com/images/svg/NavProfileIcon.svg"
                    }
                    alt="ContactIcon"
                  />
                </div>
                {sideinvestorMenu && !investorMenu && (
                  <AnimatePresence>
                    <motion.div
                      initial={{ opacity: 0, y: -10, scale: 0.95 }}
                      animate={{ opacity: 1, y: 0, scale: 1 }}
                      exit={{ opacity: 0, y: -10, scale: 0.95 }}
                      transition={{ duration: 0.2, ease: "easeOut" }}
                      onMouseLeave={() => {
                        setSideinvestorMenu(false);
                      }}
                      className="profile-dropdown contact-ab"
                    >
                      {/* <div
                        style={{ width: `${loginLoading ? "200px" : "295px"}` }}
                      >
                        {loginLoading ? (
                          <ShimmerOfCardLoader />
                        ) : (
                          <p style={{ fontFamily: "var(--OpenSans-Bold)" }}>
                            {userName}
                          </p>
                        )}
                      </div>
                      <hr />
                      <div style={{ width: "295px" }}>
                        {loginLoading ? (
                          <ShimmerOfCardLoader />
                        ) : (
                          <p style={{ fontFamily: "var(--OpenSans-Bold)" }}>
                            {userLoginData?.email}
                          </p>
                        )}
                      </div>
                      <hr />
                      <div
                        onClick={() => {
                          if (!loginLoading) UserLogOut();
                        }}
                      >
                        <img
                          style={{ width: "18px", height: "18px" }}
                          src="https://public.ticca.com/images/svg/LogOut.svg"
                          alt="logOut"
                        />
                        <p>Log-out</p>
                      </div>
                      <hr /> */}
                      {/* <div style={{ borderRadius: "0px 0px 8px 8px" }}>
                        <img
                          style={{ width: "18px", height: "18px" }}
                          src="https://public.ticca.com/images/svg/remove.svg"
                          alt="logOut"
                        />

                        <p>Remove</p>
                      </div> */}
                      <div className="gradient-bar"></div>

                      {/* Profile Header */}
                      <div className="profile-header">
                        <div className="avatar-wrapper">
                          <div className="avatar">
                            {loginLoading ? (
                              <ShimmerLoaderOneLine />
                            ) : (
                              <span> {getInitials(userName)}</span>
                            )}
                          </div>
                          <div className="online-indicator"></div>
                        </div>

                        <div className="user-info">
                          {loginLoading ? (
                            <ShimmerLoaderOneLine />
                          ) : (
                            <h3 className="user-name">{userName || "Guest"}</h3>
                          )}

                          {!loginLoading && userLoginData?.email && (
                            <p className="user-detail">{userLoginData.email}</p>
                          )}

                          {!loginLoading && userLoginData?.phone && (
                            <p className="user-detail">{userLoginData.phone}</p>
                          )}

                          {!loginLoading && userLoginData?.ip && (
                            <p className="user-meta">IP: {userLoginData.ip}</p>
                          )}

                          {!loginLoading && (() => {
                            try {
                              const t = sessionStorage.getItem("userLoginTime");
                              if (t) {
                                return <p className="user-meta">Logged in {new Date(t).toLocaleString()}</p>;
                              }
                            } catch {}
                            return null;
                          })()}
                        </div>
                      </div>

                      {/* Divider */}
                      <div className="divider"></div>

                      {/* Logout Button */}
                      <div className="logout-wrapper">
                        <motion.button
                          whileHover={{ x: 2 }}
                          whileTap={{ scale: 0.98 }}
                          transition={{ duration: 0.15 }}
                          onClick={() => {
                            if (!loginLoading) UserLogOut();
                          }}
                          className="logout-btn"
                        >
                          <div className="logout-icon">
                            <LogOut size={16} />
                          </div>
                          <span>Log out</span>
                        </motion.button>
                      </div>
                    </motion.div>
                  </AnimatePresence>
                )}
              </li>
            ) : (
              <li className="contact-img  mobile-contact">
                <Button
                  onClick={() => {
                    let Api_URL: any = "";
                    const env = process.env.REACT_APP_STAGE_ENV;
                    switch (env) {
                      case "dev":
                        Api_URL = process.env.REACT_APP_TICCA_DEV_SINUP;
                        break;
                      case "stage":
                        Api_URL = process.env.REACT_APP_TICCA_STAGE_SINUP;
                        break;
                      case "prod":
                        Api_URL = process.env.REACT_APP_TICCA_PRO_SINUP;
                        break;
                      default:
                        Api_URL = process.env.REACT_APP_TICCA_DEV_SINUP;
                        break;
                    }
                    window.location.href = Api_URL;
                  }}
                  className="btn-ticca-nav"
                  type="submit"
                >
                  Sign Up
                </Button>
              </li>
            )}
            <div
              onClick={() => {
                setmenuTogle(true);
                setInvestoeMenu(false);
                setSideinvestorMenu(false);
              }}
              className="mobile-navBar"
            >
              <button className="hamburger-btn" aria-label="Open menu">
                <span className="hamburger-line" />
                <span className="hamburger-line" />
                <span className="hamburger-line" />
              </button>
            </div>
          </div>
        </div>
      </>
    );
  };

  return (
    <>
      <Drawer
        open={
          showInvestorMenu &&
          isMobile &&
          openMenus &&
          userLoginData.status == 200
        }
        onOpenChange={setShowInvestorMenu}
      >
        <DrawerContent
          className={` nvestor-drawer max-h-[85vh] transition-colors ${
            menuTheme === "dark"
              ? "bg-gradient-to-b from-[#0a0e27] to-[#0d1230] border-cyan-500/20"
              : "bg-gradient-to-b from-white to-gray-50 border-gray-300"
          }`}
        >
          <DrawerHeader
            className={`pb-4 ${
              menuTheme === "dark"
                ? "border-b border-cyan-500/20"
                : "border-b border-gray-200"
            }`}
          >
            <div className="flex items-center justify-between">
              <div>
                <DrawerTitle
                  className={`flex items-center gap-2 ${
                    menuTheme === "dark" ? "text-white" : "text-gray-900"
                  }`}
                >
                  <TrendingUp
                    className={`w-5 h-5 ${
                      menuTheme === "dark" ? "text-cyan-400" : "text-cyan-600"
                    }`}
                  />
                  Investor Menu
                </DrawerTitle>
                <DrawerDescription
                  className={`text-sm mt-1 ${
                    menuTheme === "dark" ? "text-gray-400" : "text-gray-600"
                  }`}
                >
                  Access investor resources and documentation
                </DrawerDescription>
              </div>
              <div className="flex items-center gap-2">
                {/* Theme Toggle - Simple Icon Button */}
                <motion.button
                  onClick={() =>
                    setMenuTheme(menuTheme === "dark" ? "light" : "dark")
                  }
                  className={`p-2 rounded-lg transition-all duration-300 ${
                    menuTheme === "dark"
                      ? "bg-cyan-500/10 hover:bg-cyan-500/20 border border-cyan-500/30"
                      : "bg-white hover:bg-gray-50 border border-gray-300 shadow-sm"
                  }`}
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                >
                  {menuTheme === "dark" ? (
                    <Sun className="w-4 h-4 text-cyan-400" />
                  ) : (
                    <Moon className="w-4 h-4 text-gray-700" />
                  )}
                </motion.button>
                <button
                  onClick={() => setShowInvestorMenu(false)}
                  className={`p-2 rounded-lg transition-all ${
                    menuTheme === "dark"
                      ? "bg-cyan-500/10 hover:bg-cyan-500/20 border border-cyan-500/30"
                      : "bg-gray-100 hover:bg-gray-200 border border-gray-300"
                  }`}
                >
                  <X
                    className={`w-4 h-4 ${
                      menuTheme === "dark" ? "text-cyan-400" : "text-gray-700"
                    }`}
                  />
                </button>
              </div>
            </div>
          </DrawerHeader>

          <div className="overflow-y-auto px-4 pb-6">
            <Accordion
              type="single"
              collapsible
              className="w-full space-y-2 mt-4 "
            >
              {/* Intro Section */}
              <AccordionItem
                value="intro"
                className={`border rounded-lg overflow-hidden ${
                  menuTheme === "dark"
                    ? "border-cyan-500/20 bg-cyan-500/5"
                    : "border-cyan-200 bg-cyan-50/50"
                }`}
              >
                <AccordionTrigger
                  className={`!px-4 !py-3 hover:no-underline transition-colors ${
                    menuTheme === "dark"
                      ? "hover:bg-cyan-500/10"
                      : "hover:bg-cyan-100/50"
                  }`}
                >
                  <div className="flex items-center gap-3">
                    <div
                      className={`w-8 h-8 rounded-lg flex items-center justify-center ${
                        menuTheme === "dark"
                          ? "bg-gradient-to-br from-cyan-500/20 to-blue-500/20"
                          : "bg-gradient-to-br from-cyan-100 to-blue-100"
                      }`}
                    >
                      <FileText
                        className={`w-4 h-4 ${
                          menuTheme === "dark"
                            ? "text-cyan-400"
                            : "text-cyan-600"
                        }`}
                      />
                    </div>
                    <span
                      className={
                        menuTheme === "dark" ? "text-white" : "text-gray-900"
                      }
                    >
                      Intro
                    </span>
                  </div>
                </AccordionTrigger>
                <AccordionContent className="!px-4 !py-3">
                  <div className="space-y-1 pt-2">
                    <button
                      onClick={(e) => {
                        e.preventDefault();
                        setShowInvestorMenu(false);
                        setDocId("");
                        navigation(PageRoutes.Intro);
                      }}
                      className={`w-full flex items-center justify-between px-3 py-2 rounded-lg transition-all !text-green-400 hover:text-white hover:bg-cyan-500/10`}
                    >
                      <div className="flex items-center gap-2">
                        <div className="w-1.5 h-1.5 rounded-full bg-cyan-400" />
                        <span>Intro</span>
                      </div>
                      {<CheckCircle className="w-3 h-3 text-green-400" />}
                    </button>
                    <button
                      onClick={(e) => {
                        e.preventDefault();
                        setShowInvestorMenu(false);
                        setDocId("");
                        navigation(PageRoutes.faq);
                      }}
                      className={`w-full flex items-center justify-between px-3 py-2 rounded-lg transition-all !text-green-400 hover:text-white hover:bg-cyan-500/10`}
                    >
                      <div className="flex items-center gap-2">
                        <div className="w-1.5 h-1.5 rounded-full bg-cyan-400" />
                        <span>FAQ</span>
                      </div>
                      {<CheckCircle className="w-3 h-3 text-green-400" />}
                    </button>
                    <button
                      onClick={(e) => {
                        e.preventDefault();
                        setShowInvestorMenu(false);
                        setDocId("");
                        navigation(PageRoutes.factSheet);
                      }}
                      className={`w-full flex items-center justify-between px-3 py-2 rounded-lg transition-all !text-green-400 hover:text-white hover:bg-cyan-500/10`}
                    >
                      <div className="flex items-center gap-2">
                        <div className="w-1.5 h-1.5 rounded-full bg-cyan-400" />
                        <span>Fact Sheet</span>
                      </div>
                      {<CheckCircle className="w-3 h-3 text-green-400" />}
                    </button>
                  </div>
                </AccordionContent>
              </AccordionItem>
              {/* Business Plan Section */}
              <AccordionItem
                value="business"
                className={`border rounded-lg overflow-hidden ${
                  menuTheme === "dark"
                    ? "border-cyan-500/20 bg-cyan-500/5"
                    : "border-cyan-200 bg-cyan-50/50"
                }`}
              >
                <AccordionTrigger
                  className={`!px-4 !py-3 hover:no-underline transition-colors ${
                    menuTheme === "dark"
                      ? "hover:bg-cyan-500/10"
                      : "hover:bg-cyan-100/50"
                  }`}
                >
                  <div className="flex items-center gap-3">
                    <div
                      className={`w-8 h-8 rounded-lg flex items-center justify-center ${
                        menuTheme === "dark"
                          ? "bg-gradient-to-br from-cyan-500/20 to-blue-500/20"
                          : "bg-gradient-to-br from-cyan-100 to-blue-100"
                      }`}
                    >
                      <Building2
                        className={`w-4 h-4 ${
                          menuTheme === "dark"
                            ? "text-cyan-400"
                            : "text-cyan-600"
                        }`}
                      />
                    </div>
                    <span
                      className={
                        menuTheme === "dark" ? "text-white" : "text-gray-900"
                      }
                    >
                      Business Plan
                    </span>
                  </div>
                </AccordionTrigger>
                <AccordionContent className="!px-4 !py-3">
                  <div className="space-y-1 pt-2">
                    <button
                      onClick={(e) => {
                        e.preventDefault();
                        setShowInvestorMenu(false);
                        if (accessDoc["13678"] == "ALLOWED") {
                          navigation(PageRoutes.ExecutiveSummary);
                          setShowInvestorMenu(false);
                        } else if (accessDoc["13678"] == "PENDING") {
                          setShowPandingBussness(true);
                        } else if (accessDoc["13678"] == "DENIED") {
                          setShowAccessDenied(true);
                        } else {
                          setShowLockBussness(true);
                        }
                      }}
                      className={`w-full flex items-center justify-between px-3 py-2 rounded-lg transition-all ${
                        accessDoc["13678"] == "ALLOWED"
                          ? "text-green-400 hover:text-green-300 hover:bg-green-500/10"
                          : accessDoc["13678"] == "DENIED"
                            ? "text-red-400 hover:text-red-300 hover:bg-red-500/10"
                            : accessDoc["13678"] == "PENDING"
                              ? "text-yellow-400 cursor-wait"
                              : "!text-gray-300 hover:text-white hover:bg-cyan-500/10"
                      }`}
                    >
                      <div className="flex items-center gap-2">
                        <div className="w-1.5 h-1.5 rounded-full bg-cyan-400" />
                        <span>Business Summary</span>
                      </div>
                      {accessDoc["13678"] === "PENDING" ? (
                        <Clock className="w-3 h-3 text-yellow-400 animate-pulse" />
                      ) : accessDoc["13678"] === "ALLOWED" ? (
                        <CheckCircle className="w-3 h-3 text-green-400" />
                      ) : accessDoc["13678"] === "DENIED" ? (
                        <XCircle className="w-3 h-3 text-red-400" />
                      ) : (
                        accessDoc["13678"] === "" && (
                          <Lock className="w-3 h-3 text-gray-500" />
                        )
                      )}
                    </button>
                    <button
                      onClick={(e) => {
                        e.preventDefault();
                        setShowInvestorMenu(false);
                        if (accessDoc["9431"] == "ALLOWED") {
                          navigation(PageRoutes.qa);
                          setShowInvestorMenu(false);
                        } else if (accessDoc["9431"] == "PENDING") {
                          setShowPandingBussness(true);
                        } else if (accessDoc["9431"] == "DENIED") {
                          setShowAccessDenied(true);
                        } else {
                          setShowLockBussness(true);
                        }
                      }}
                      className={`w-full flex items-center justify-between px-3 py-2 rounded-lg transition-all ${
                        accessDoc["9431"] === "ALLOWED"
                          ? "text-green-400 hover:text-green-300 hover:bg-green-500/10"
                          : accessDoc["9431"] === "DENIED"
                            ? "text-red-400 hover:text-red-300 hover:bg-red-500/10"
                            : accessDoc["9431"] === "PENDING"
                              ? "text-yellow-400 cursor-wait"
                              : "!text-gray-300 hover:text-white hover:bg-cyan-500/10"
                      }`}
                    >
                      <div className="flex items-center gap-2">
                        <div className="w-1.5 h-1.5 rounded-full bg-cyan-400" />
                        <span>Q & A</span>
                      </div>
                      {accessDoc["9431"] === "PENDING" ? (
                        <Clock className="w-3 h-3 text-yellow-400 animate-pulse" />
                      ) : accessDoc["9431"] === "ALLOWED" ? (
                        <CheckCircle className="w-3 h-3 text-green-400" />
                      ) : accessDoc["9431"] === "DENIED" ? (
                        <XCircle className="w-3 h-3 text-red-400" />
                      ) : (
                        accessDoc["9431"] === "" && (
                          <Lock className="w-3 h-3 text-gray-500" />
                        )
                      )}
                    </button>
                    <button
                      onClick={(e) => {
                        e.preventDefault();
                        setShowInvestorMenu(false);
                        if (accessDoc["13029"] == "ALLOWED") {
                          navigation(PageRoutes.AI_Executive_Summary);
                        } else if (accessDoc["13029"] == "PENDING") {
                          setShowPandingBussness(true);
                        } else if (accessDoc["13029"] == "DENIED") {
                          setShowAccessDenied(true);
                        } else {
                          setShowLockBussness(true);
                        }
                      }}
                      className={`w-full flex items-center justify-between px-3 py-2 rounded-lg transition-all ${
                        accessDoc["13029"] === "ALLOWED"
                          ? "text-green-400 hover:text-green-300 hover:bg-green-500/10"
                          : accessDoc["13029"] === "DENIED"
                            ? "text-red-400 hover:text-red-300 hover:bg-red-500/10"
                            : accessDoc["13029"] === "PENDING"
                              ? "text-yellow-400 cursor-wait"
                              : "text-gray-300 hover:text-white hover:bg-cyan-500/10"
                      }`}
                    >
                      <div className="flex items-center gap-2">
                        <div className="w-1.5 h-1.5 rounded-full bg-cyan-400" />
                        <span>AI Executive Summary</span>
                      </div>
                      {accessDoc["13029"] === "PENDING" ? (
                        <Clock className="w-3 h-3 text-yellow-400 animate-pulse" />
                      ) : accessDoc["13029"] === "ALLOWED" ? (
                        <CheckCircle className="w-3 h-3 text-green-400" />
                      ) : accessDoc["13029"] === "DENIED" ? (
                        <XCircle className="w-3 h-3 text-red-400" />
                      ) : (
                        accessDoc["13029"] === "" && (
                          <Lock className="w-3 h-3 text-gray-500" />
                        )
                      )}
                    </button>
                  </div>
                </AccordionContent>
              </AccordionItem>

              {/* Financial Summary Section */}
              <AccordionItem
                value="financial"
                className={`border rounded-lg overflow-hidden ${
                  menuTheme === "dark"
                    ? "border-cyan-500/20 bg-cyan-500/5"
                    : "border-cyan-200 bg-cyan-50/50"
                }`}
              >
                <AccordionTrigger
                  className={`!px-4 !py-3 hover:no-underline transition-colors ${
                    menuTheme === "dark"
                      ? "hover:bg-cyan-500/10"
                      : "hover:bg-cyan-100/50"
                  }`}
                >
                  <div className="flex items-center gap-3">
                    <div
                      className={`w-8 h-8 rounded-lg flex items-center justify-center ${
                        menuTheme === "dark"
                          ? "bg-gradient-to-br from-cyan-500/20 to-blue-500/20"
                          : "bg-gradient-to-br from-cyan-100 to-blue-100"
                      }`}
                    >
                      <DollarSign
                        className={`w-4 h-4 ${
                          menuTheme === "dark"
                            ? "text-cyan-400"
                            : "text-cyan-600"
                        }`}
                      />
                    </div>
                    <span
                      className={
                        menuTheme === "dark" ? "text-white" : "text-gray-900"
                      }
                    >
                      Financial Summary
                    </span>
                  </div>
                </AccordionTrigger>
                <AccordionContent className="!px-4 !py-3">
                  <div className="space-y-1 pt-2">
                    <button
                      onClick={(e) => {
                        e.preventDefault();
                        setShowInvestorMenu(false);
                        if (accessDoc["13656"] == "ALLOWED") {
                          navigation(PageRoutes.Projections);
                        } else if (accessDoc["13656"] == "PENDING") {
                          setpendingPop(true);
                        } else if (accessDoc["13656"] == "DENIED") {
                          setShowAccessDenied(true);
                        } else {
                          setShowFinancialPopup(true);
                        }
                      }}
                      className={`w-full flex items-center justify-between px-3 py-2 rounded-lg transition-all ${
                        accessDoc["13656"] == "ALLOWED"
                          ? "text-green-400 hover:text-green-300 hover:bg-green-500/10"
                          : accessDoc["13656"] == "DENIED"
                            ? "text-red-400 hover:text-red-300 hover:bg-red-500/10"
                            : accessDoc["13656"] == "PENDING"
                              ? "text-yellow-400 cursor-wait"
                              : "!text-gray-300 hover:text-white hover:bg-cyan-500/10"
                      }`}
                    >
                      <div className="flex items-center gap-2">
                        <div className="w-1.5 h-1.5 rounded-full bg-cyan-400" />
                        <span>Financial Projection 2027</span>
                      </div>
                      {accessDoc["13656"] === "PENDING" ? (
                        <Clock className="w-3 h-3 text-yellow-400 animate-pulse" />
                      ) : accessDoc["13656"] === "ALLOWED" ? (
                        <CheckCircle className="w-3 h-3 text-green-400" />
                      ) : accessDoc["13656"] === "DENIED" ? (
                        <XCircle className="w-3 h-3 text-red-400" />
                      ) : (
                        accessDoc["13656"] === "" && (
                          <Lock className="w-3 h-3 text-gray-500" />
                        )
                      )}
                    </button>
                  </div>
                </AccordionContent>
              </AccordionItem>

              {/* Investor Instrument Section */}
              <AccordionItem
                value="instrument"
                className={`border rounded-lg overflow-hidden ${
                  menuTheme === "dark"
                    ? "border-cyan-500/20 bg-cyan-500/5"
                    : "border-cyan-200 bg-cyan-50/50"
                }`}
              >
                <AccordionTrigger
                  className={`!px-4 !py-3 hover:no-underline transition-colors ${
                    menuTheme === "dark"
                      ? "hover:bg-cyan-500/10"
                      : "hover:bg-cyan-100/50"
                  }`}
                >
                  <div className="flex items-center gap-3">
                    <div
                      className={`w-8 h-8 rounded-lg flex items-center justify-center ${
                        menuTheme === "dark"
                          ? "bg-gradient-to-br from-cyan-500/20 to-blue-500/20"
                          : "bg-gradient-to-br from-cyan-100 to-blue-100"
                      }`}
                    >
                      <Scale
                        className={`w-4 h-4 ${
                          menuTheme === "dark"
                            ? "text-cyan-400"
                            : "text-cyan-600"
                        }`}
                      />
                    </div>
                    <span
                      className={
                        menuTheme === "dark" ? "text-white" : "text-gray-900"
                      }
                    >
                      Investor Instrument
                    </span>
                  </div>
                </AccordionTrigger>
                <AccordionContent className="!px-4 !py-3">
                  <div className="space-y-1 pt-2">
                    <button
                      onClick={(e) => {
                        e.preventDefault();
                        setShowInvestorMenu(false);
                        if (accessDoc["11482"] == "ALLOWED") {
                          navigation(PageRoutes.SafeFrom);
                        } else if (accessDoc["11482"] == "PENDING") {
                          setpendingPop(true);
                        } else if (accessDoc["11482"] == "DENIED") {
                          setShowAccessDenied(true);
                        } else {
                          setShowFinancialPopup(true);
                        }
                      }}
                      className={`w-full flex items-center justify-between px-3 py-2 rounded-lg transition-all ${
                        accessDoc["11482"] == "ALLOWED"
                          ? "text-green-400 hover:text-green-300 hover:bg-green-500/10"
                          : accessDoc["11482"] == "DENIED"
                            ? "text-red-400 hover:text-red-300 hover:bg-red-500/10"
                            : accessDoc["11482"] == "PENDING"
                              ? "text-yellow-400 cursor-wait"
                              : "!text-gray-300 hover:text-white hover:bg-cyan-500/10"
                      }`}
                    >
                      <div className="flex items-center gap-2">
                        <div className="w-1.5 h-1.5 rounded-full bg-cyan-400" />
                        <span>SAFE Agreement</span>
                      </div>
                      {accessDoc["11482"] === "PENDING" ? (
                        <Clock className="w-3 h-3 text-yellow-400 animate-pulse" />
                      ) : accessDoc["11482"] === "ALLOWED" ? (
                        <CheckCircle className="w-3 h-3 text-green-400" />
                      ) : accessDoc["11482"] === "DENIED" ? (
                        <XCircle className="w-3 h-3 text-red-400" />
                      ) : (
                        accessDoc["11482"] === "" && (
                          <Lock className="w-3 h-3 text-gray-500" />
                        )
                      )}
                    </button>
                  </div>
                </AccordionContent>
              </AccordionItem>

              {/* Corporate Governance Section */}
              <AccordionItem
                value="governance"
                className={`border rounded-lg overflow-hidden ${
                  menuTheme === "dark"
                    ? "border-cyan-500/20 bg-cyan-500/5"
                    : "border-cyan-200 bg-cyan-50/50"
                }`}
              >
                <AccordionTrigger
                  className={`!px-4 !py-3 hover:no-underline transition-colors ${
                    menuTheme === "dark"
                      ? "hover:bg-cyan-500/10"
                      : "hover:bg-cyan-100/50"
                  }`}
                >
                  <div className="flex items-center gap-3">
                    <div
                      className={`w-8 h-8 rounded-lg flex items-center justify-center ${
                        menuTheme === "dark"
                          ? "bg-gradient-to-br from-cyan-500/20 to-blue-500/20"
                          : "bg-gradient-to-br from-cyan-100 to-blue-100"
                      }`}
                    >
                      <Shield
                        className={`w-4 h-4 ${
                          menuTheme === "dark"
                            ? "text-cyan-400"
                            : "text-cyan-600"
                        }`}
                      />
                    </div>
                    <span
                      className={
                        menuTheme === "dark" ? "text-white" : "text-gray-900"
                      }
                    >
                      Corporate Governance
                    </span>
                  </div>
                </AccordionTrigger>
                <AccordionContent className="!px-4 !pb-3">
                  <div className="space-y-1 pt-2">
                    <button
                      onClick={(e) => {
                        e.preventDefault();
                        setShowInvestorMenu(false);
                        if (accessDoc["12146"] == "ALLOWED") {
                          navigation(PageRoutes.CorporateGovernancePolicy);
                        } else if (accessDoc["12146"] == "PENDING") {
                          setpendingPop(true);
                        } else if (accessDoc["12146"] == "DENIED") {
                          setShowAccessDenied(true);
                        } else {
                          setShowFinancialPopup(true);
                        }
                      }}
                      className={`w-full flex items-center justify-between px-3 py-2 rounded-lg transition-all ${
                        accessDoc["12146"] == "ALLOWED"
                          ? "text-green-400 hover:text-green-300 hover:bg-green-500/10"
                          : accessDoc["12146"] == "DENIED"
                            ? "text-red-400 hover:text-red-300 hover:bg-red-500/10"
                            : accessDoc["12146"] == "PENDING"
                              ? "text-yellow-400 cursor-wait"
                              : "!text-gray-300 hover:text-white hover:bg-cyan-500/10"
                      }`}
                    >
                      <div className="flex items-center gap-2">
                        <div className="w-1.5 h-1.5 rounded-full bg-cyan-400" />
                        <span>Corporate Governance Policy</span>
                      </div>
                      {accessDoc["12146"] === "PENDING" ? (
                        <Clock className="w-3 h-3 text-yellow-400 animate-pulse" />
                      ) : accessDoc["12146"] === "ALLOWED" ? (
                        <CheckCircle className="w-3 h-3 text-green-400" />
                      ) : accessDoc["12146"] === "DENIED" ? (
                        <XCircle className="w-3 h-3 text-red-400" />
                      ) : (
                        accessDoc["12146"] === "" && (
                          <Lock className="w-3 h-3 text-gray-500" />
                        )
                      )}
                    </button>
                    <button
                      onClick={(e) => {
                        e.preventDefault();
                        setShowInvestorMenu(false);
                        navigation(PageRoutes.AntiFraudPolicy);
                      }}
                      className={`w-full flex items-center justify-between px-3 py-2 rounded-lg transition-all !text-green-400 hover:text-white hover:bg-cyan-500/10`}
                    >
                      <div className="flex items-center gap-2">
                        <div className="w-1.5 h-1.5 rounded-full bg-cyan-400" />
                        <span>Antifraud Policy</span>
                      </div>
                      {<CheckCircle className="w-3 h-3 text-green-400" />}
                    </button>
                    <button
                      onClick={(e) => {
                        e.preventDefault();
                        setShowInvestorMenu(false);
                        navigation(PageRoutes.WhistleblowerPolicy);
                      }}
                      className={`w-full flex items-center justify-between px-3 py-2 rounded-lg transition-all !text-green-400 hover:text-white hover:bg-cyan-500/10`}
                    >
                      <div className="flex items-center gap-2">
                        <div className="w-1.5 h-1.5 rounded-full bg-cyan-400" />
                        <span>Whistleblower Policy</span>
                      </div>
                      {<CheckCircle className="w-3 h-3 text-green-400" />}
                    </button>
                    <button
                      onClick={(e) => {
                        e.preventDefault();
                        setShowInvestorMenu(false);
                        navigation(PageRoutes.DataSecurityPolicy);
                      }}
                      className={`w-full flex items-center justify-between px-3 py-2 rounded-lg transition-all !text-green-400 hover:text-white hover:bg-cyan-500/10`}
                    >
                      <div className="flex items-center gap-2">
                        <div className="w-1.5 h-1.5 rounded-full bg-cyan-400" />
                        <span>Data Security & Privacy</span>
                      </div>
                      {<CheckCircle className="w-3 h-3 text-green-400" />}
                    </button>
                    <button
                      onClick={(e) => {
                        e.preventDefault();
                        setShowInvestorMenu(false);
                        navigation(PageRoutes.TeamsOfUse);
                      }}
                      className={`w-full flex items-center justify-between px-3 py-2 rounded-lg transition-all !text-green-400 hover:text-white hover:bg-cyan-500/10`}
                    >
                      <div className="flex items-center gap-2">
                        <div className="w-1.5 h-1.5 rounded-full bg-cyan-400" />
                        <span>Terms of Use</span>
                      </div>
                      {<CheckCircle className="w-3 h-3 text-green-400" />}
                    </button>
                    <button
                      onClick={(e) => {
                        e.preventDefault();
                        setShowInvestorMenu(false);
                        navigation(PageRoutes.PrivacyPolicy);
                      }}
                      className={`w-full flex items-center justify-between px-3 py-2 rounded-lg transition-all !text-green-400 hover:text-white hover:bg-cyan-500/10`}
                    >
                      <div className="flex items-center gap-2">
                        <div className="w-1.5 h-1.5 rounded-full bg-cyan-400" />
                        <span>Privacy Policy</span>
                      </div>
                      {<CheckCircle className="w-3 h-3 text-green-400" />}
                    </button>
                    <button
                      onClick={(e) => {
                        e.preventDefault();
                        setShowInvestorMenu(false);
                        navigation(PageRoutes.CookiePolicy);
                      }}
                      className={`w-full flex items-center justify-between px-3 py-2 rounded-lg transition-all !text-green-400 hover:text-white hover:bg-cyan-500/10`}
                    >
                      <div className="flex items-center gap-2">
                        <div className="w-1.5 h-1.5 rounded-full bg-cyan-400" />
                        <span>Cookie Policy</span>
                      </div>
                      {<CheckCircle className="w-3 h-3 text-green-400" />}
                    </button>
                       <button
                      onClick={(e) => {
                        e.preventDefault();
                        setShowInvestorMenu(false);
                        navigation(PageRoutes.InvestorRelationsPolicy);
                      }}
                      className={`w-full flex items-center justify-between px-3 py-2 rounded-lg transition-all !text-green-400 hover:text-white hover:bg-cyan-500/10`}
                    >
                      <div className="flex items-center gap-2">
                        <div className="w-1.5 h-1.5 rounded-full bg-cyan-400" />
                        <span>Investor Relations Policy</span>
                      </div>
                      {<CheckCircle className="w-3 h-3 text-green-400" />}
                    </button>
                  </div>
                </AccordionContent>
              </AccordionItem>

              {/* WWW Section */}
              <AccordionItem
                value="www"
                className={`border rounded-lg overflow-hidden ${
                  menuTheme === "dark"
                    ? "border-cyan-500/20 bg-cyan-500/5"
                    : "border-cyan-200 bg-cyan-50/50"
                }`}
              >
                <AccordionTrigger
                  className={`!px-4 !py-3 hover:no-underline transition-colors ${
                    menuTheme === "dark"
                      ? "hover:bg-cyan-500/10"
                      : "hover:bg-cyan-100/50"
                  }`}
                >
                  <div className="flex items-center gap-3">
                    <div
                      className={`w-8 h-8 rounded-lg flex items-center justify-center ${
                        menuTheme === "dark"
                          ? "bg-gradient-to-br from-cyan-500/20 to-blue-500/20"
                          : "bg-gradient-to-br from-cyan-100 to-blue-100"
                      }`}
                    >
                      <Globe
                        className={`w-4 h-4 ${
                          menuTheme === "dark"
                            ? "text-cyan-400"
                            : "text-cyan-600"
                        }`}
                      />
                    </div>
                    <span
                      className={
                        menuTheme === "dark" ? "text-white" : "text-gray-900"
                      }
                    >
                      WWW
                    </span>
                  </div>
                </AccordionTrigger>
                <AccordionContent className="!px-4 !pb-3">
                  <div className="space-y-1 pt-2">
                    <button
                      onClick={(e) => {
                        e.preventDefault();
                        let Api_URL: any = "";
                        const env = process.env.REACT_APP_STAGE_ENV;
                        switch (env) {
                          case "dev":
                            Api_URL = `https://dev.www.ticca.com`;
                            break;
                          case "stage":
                            Api_URL = `https:/stage.www.ticca.com`;
                            break;
                          case "prod":
                            Api_URL = `https://www.ticca.com`;
                            break;
                          default:
                            Api_URL = `https://dev.www.ticca.com`;
                        }
                        setShowInvestorMenu(false);
                        window.open(Api_URL, "_blank", "noopener,noreferrer");
                        setShowInvestorMenu(false);
                      }}
                      className={`w-full flex items-center justify-between px-3 py-2 rounded-lg transition-all 
                           text-green-400 hover:text-green-300 hover:bg-green-500/10
                         `}
                    >
                      <div className="flex items-center gap-2">
                        <div className="w-1.5 h-1.5 rounded-full bg-cyan-400" />
                        <span>ticca.com</span>
                      </div>
                      <CheckCircle className="w-3 h-3 text-green-400" />
                    </button>
                    <button
                      onClick={(e) => {
                        e.preventDefault();
                        let Api_URL: any = "";
                        const env = process.env.REACT_APP_STAGE_ENV;
                        switch (env) {
                          case "dev":
                            Api_URL = `https://dev.www.ticca.ai`;
                            break;
                          case "stage":
                            Api_URL = `https:/stage.www.ticca.ai`;
                            break;
                          case "prod":
                            Api_URL = `https://www.ticca.ai`;
                            break;
                          default:
                            Api_URL = `https://dev.www.ticca.ai`;
                        }
                        setShowInvestorMenu(false);
                        window.open(Api_URL, "_blank", "noopener,noreferrer");
                        setShowInvestorMenu(false);
                      }}
                      className={`w-full flex items-center justify-between px-3 py-2 rounded-lg transition-all 
                           text-green-400 hover:text-green-300 hover:bg-green-500/10
                         `}
                    >
                      <div className="flex items-center gap-2">
                        <div className="w-1.5 h-1.5 rounded-full bg-cyan-400" />
                        <span>ticca.ai</span>
                      </div>
                      <CheckCircle className="w-3 h-3 text-green-400" />
                    </button>
                    <button
                      disabled={true}
                      onClick={(e) => {
                        e.preventDefault();
                        return;
                      }}
                      style={{ opacity: "0.6" }}
                      className={`w-full flex items-center justify-between px-3 py-2 rounded-lg transition-all 
                          !text-gray-500 hover:text-white hover:bg-cyan-500/10
                         `}
                    >
                      <div className="flex items-center gap-2">
                        <div className="w-1.5 h-1.5 rounded-full bg-cyan-400" />
                        <span>ticca.work</span>
                      </div>
                      <Lock className="w-3 h-3 text-gray-500" />
                    </button>
                    <button
                      disabled={true}
                      onClick={(e) => {
                        e.preventDefault();
                        return;
                      }}
                      style={{ opacity: "0.6" }}
                      className={`w-full flex items-center justify-between px-3 py-2 rounded-lg transition-all 
                          !text-gray-500 hover:text-white hover:bg-cyan-500/10
                         `}
                    >
                      <div className="flex items-center gap-2">
                        <div className="w-1.5 h-1.5 rounded-full bg-cyan-400" />
                        <span>preview.ticca.ltd</span>
                      </div>
                      <Lock className="w-3 h-3 text-gray-500" />
                    </button>
                  </div>
                </AccordionContent>
              </AccordionItem>
            </Accordion>
          </div>
        </DrawerContent>
      </Drawer>
      <div
        className="navBar-main-container nav-default"
        style={{
          backgroundColor: `${
            colorChange && !ppm
              ? "oklab(17.6822% .00285986 -.0511668 )"
              : "oklab(17.6822% .00285986 -.0511668 )"
          }`,
        }}
      >
        {NavBarComm()}
      </div>
      {menuTogle && isMobile && (
        <AnimatePresence>
          {/* Overlay */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.25 }}
            onClick={() => setmenuTogle(false)}
            className="fixed inset-0 z-[99998] bg-black/60 backdrop-blur-sm"
          />

          {/* Slide Menu */}
          <motion.div
            initial={{ x: "100%" }}
            animate={{ x: 0 }}
            exit={{ x: "100%" }}
            transition={{ type: "spring", damping: 28, stiffness: 300 }}
            className="fixed top-0 right-0 bottom-0 z-[99999] w-80 bg-gradient-to-b from-[#051525] to-[#02101c] shadow-2xl p-6 text-white flex flex-col"
          >
            {/* Close + Logo row */}
            <div className="flex items-center justify-between mb-8">
              <span className="text-sm font-semibold uppercase tracking-[0.15em] text-cyan-300/80">Menu</span>
              <button
                onClick={() => setmenuTogle(false)}
                className="flex items-center justify-center w-9 h-9 rounded-xl bg-white/10 hover:bg-white/20 transition-colors"
              >
                <X className="w-5 h-5 text-white/80" />
              </button>
            </div>

            {/* Menu Items */}
            <nav className="flex-1 overflow-y-auto">
              <ul className="space-y-1">
                {[
                  { label: "What", route: PageRoutes.ticcaProduct },
                  { label: "Where", route: PageRoutes.WorkFromAnywhere },
                  { label: "How", route: PageRoutes.innovation },
                  { label: "Who", route: PageRoutes.aboutUs },
                  { label: "Why", route: PageRoutes.WhyChooseUs },
                  { label: "When", route: PageRoutes.When },
                  { label: "Investor", route: PageRoutes.InvestorCenter },
                  { label: "Insights", route: PageRoutes.insights },
                  { label: "Contact", route: PageRoutes.ContactUs },
                ].map((item, i) => (
                  <motion.li
                    key={i}
                    initial={{ opacity: 0, x: 24 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ delay: 0.08 + i * 0.04, duration: 0.3, ease: "easeOut" }}
                    onClick={() => {
                      navigation(item.route);
                      setmenuTogle(false);
                    }}
                    className={`px-4 py-3 rounded-xl cursor-pointer text-sm font-medium transition-all ${
                      window.location.pathname === item.route
                        ? "bg-cyan-500/15 text-cyan-300 border border-cyan-500/20"
                        : "text-white/70 hover:text-white hover:bg-white/8"
                    }`}
                  >
                    {item.label}
                  </motion.li>
                ))}
              </ul>
            </nav>

            {/* Log in button at bottom */}
            {userLoginData.status === 404 && (
              <motion.div
                initial={{ opacity: 0, y: 16 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.45, duration: 0.3 }}
                className="mt-auto pt-6 border-t border-white/10"
              >
                <button
                  onClick={() => {
                    let Api_URL = "";
                    const env = process.env.REACT_APP_STAGE_ENV;
                    switch (env) {
                      case "dev":
                        Api_URL = "https://dev.login.ticca.com/?domain=dev.www.ticca.ltd";
                        break;
                      case "stage":
                        Api_URL = "https://stage.login.ticca.com/?domain=stage.www.ticca.ltd";
                        break;
                      case "prod":
                        Api_URL = "https://login.ticca.com/?domain=www.ticca.ltd";
                        break;
                      default:
                        Api_URL = "https://dev.login.ticca.com/?domain=dev.www.ticca.ltd";
                    }
                    window.location.href = Api_URL;
                  }}
                  className="w-full py-3 text-sm font-semibold text-[#3d71d9] bg-white rounded-xl border border-[#3d71d9] hover:bg-gray-50 active:scale-95 transition-all"
                >
                  Log in
                </button>
              </motion.div>
            )}
          </motion.div>
        </AnimatePresence>
      )}

      {openMenus &&
        investorMenu &&
        userLoginData.status == 200 &&
        !sideinvestorMenu && (
          <AnimatePresence>
            {investorMenu && !isMobile && (
              <>
                {/* Backdrop */}
                <motion.div
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  onClick={() => setInvestoeMenu(false)}
                  className="investor-backdrop"
                />

                {/* Menu Panel */}
                <motion.div
                  initial={{ opacity: 0, y: -20 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -20 }}
                  transition={{ duration: 0.3 }}
                  className={`investor-menu ${menuTheme}`}
                >
                  <div className="investor-menu__content">
                    <div className="investor-menu__grid">
                      {/* Column 1 */}
                      <div className="investor-col">
                        <Section
                          title="Intro"
                          theme={menuTheme}
                          icon={<FileText />}
                          links={[
                            {
                              name: "Intro",
                              href: `${PageRoutes.Intro}`,
                              unlock: true,
                            },
                            {
                              name: "FAQ",
                              href: `${PageRoutes.faq}`,
                              unlock: true,
                            },
                            {
                              name: "Fact Sheet",
                              href: `${PageRoutes.factSheet}`,
                              unlock: true,
                            },
                          ]}
                          setShowInvestorMenu={setShowInvestorMenu}
                        />

                        <Section
                          title="Business Plan"
                          theme={menuTheme}
                          icon={<Building2 />}
                          links={[
                            {
                              name: "Business Summary",
                              href: `${PageRoutes.ExecutiveSummary}`,
                              lock: true,
                              ckeckAccess: true,
                              postId: "13678",
                            },
                            {
                              name: "Q & A",
                              href: `${PageRoutes.qa}`,
                              lock: true,
                              ckeckAccess: true,
                              postId: "9431",
                            },
                            {
                              name: "AI Executive Summary",
                              href: `${PageRoutes.AI_Executive_Summary}`,
                              lock: true,
                              postId: "13029",
                            },
                          ]}
                          setShowInvestorMenu={setShowInvestorMenu}
                        />

                        <Section
                          title="Financial Summary"
                          theme={menuTheme}
                          icon={<DollarSign />}
                          links={[
                            {
                              name: "Financial Projection ",
                              href: `${PageRoutes.Projections}`,
                              lock: true,
                              postId: "13656",
                            },
                          ]}
                          setShowInvestorMenu={setShowInvestorMenu}
                        />
                      </div>

                      {/* Column 2 */}
                      <div className="investor-col">
                        <Section
                          title="Investor Instrument"
                          theme={menuTheme}
                          icon={<Scale />}
                          links={[
                            {
                              name: "SAFE Agreement",
                              href: `${PageRoutes.SafeFrom}`,
                              lock: true,
                              postId: "11482",
                            },
                          ]}
                          setShowInvestorMenu={setShowInvestorMenu}
                        />

                        <Section
                          title="WWW"
                          theme={menuTheme}
                          icon={<Globe />}
                          links={[
                            {
                              name: "ticca.com",
                              href: "ticca.com",
                              www: true,
                              unlock: true,
                            },
                            {
                              name: "ticca.ai",
                              href: "ticca.ai",
                              www: true,
                              unlock: true,
                            },
                            {
                              name: "ticca.work",
                              href: "",

                              unlock: true,
                            },
                            {
                              name: "preview.ticca.ltd",
                              href: "",

                              unlock: true,
                            },
                          ]}
                          setShowInvestorMenu={setShowInvestorMenu}
                        />
                      </div>

                      {/* Column 3 */}
                      <div className="investor-col">
                        <Section
                          title="Corporate Governance"
                          theme={menuTheme}
                          icon={<Shield />}
                          links={[
                            {
                              name: "Corporate Governance Policy",
                              href: `${PageRoutes.CorporateGovernancePolicy}`,
                              lock: true,
                              animatedLock: true,
                              postId: "12146",
                            },
                            {
                              name: "Antifraud Policy",
                              href: `${PageRoutes.AntiFraudPolicy}`,
                              unlock: true,
                            },
                            {
                              name: "Whistleblower Policy",
                              href: `${PageRoutes.WhistleblowerPolicy}`,
                              unlock: true,
                            },
                            {
                              name: "Data Security & Privacy",
                              href: `${PageRoutes.DataSecurityPolicy}`,
                              unlock: true,
                            },
                            {
                              name: "Terms of Use",
                              href: `${PageRoutes.TeamsOfUse}`,
                              unlock: true,
                            },
                            {
                              name: "Privacy Policy",
                              href: `${PageRoutes.PrivacyPolicy}`,
                              unlock: true,
                            },
                            {
                              name: "Cookie Policy",
                              href: `${PageRoutes.CookiePolicy}`,
                              unlock: true,
                            },
                            {
                              name: "Investor Relations Policy",
                              href: `${PageRoutes.InvestorRelationsPolicy}`,
                              unlock: true,
                            },
                          ]}
                          setShowInvestorMenu={setShowInvestorMenu}
                        />
                      </div>
                    </div>

                    {/* Theme Toggle */}
                    <div className="theme-toggle">
                      <motion.button
                        onClick={(e) => {
                          e.stopPropagation();
                          setMenuTheme(menuTheme === "dark" ? "light" : "dark");
                        }}
                        whileHover={{ scale: 1.05 }}
                        whileTap={{ scale: 0.95 }}
                        className={`theme-btn ${menuTheme}`}
                      >
                        {menuTheme === "dark" ? <Sun /> : <Moon />}
                      </motion.button>
                    </div>
                  </div>
                </motion.div>
              </>
            )}
          </AnimatePresence>
        )}
    </>
  );
}

export default NavBar;
